"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ControlMessage_1 = __importDefault(require("../ControlMessage"));

var validations_1 = require("../../../utils/validations");

var MessageRef_1 = __importDefault(require("../../message_layer/MessageRef"));

var ValidationError_1 = __importDefault(require("../../../errors/ValidationError"));

var ResendRangeRequest = /*#__PURE__*/function (_ControlMessage_1$def) {
  _inherits(ResendRangeRequest, _ControlMessage_1$def);

  var _super = _createSuper(ResendRangeRequest);

  function ResendRangeRequest(_ref) {
    var _this;

    var _ref$version = _ref.version,
        version = _ref$version === void 0 ? ControlMessage_1.default.LATEST_VERSION : _ref$version,
        requestId = _ref.requestId,
        streamId = _ref.streamId,
        streamPartition = _ref.streamPartition,
        fromMsgRef = _ref.fromMsgRef,
        toMsgRef = _ref.toMsgRef,
        publisherId = _ref.publisherId,
        msgChainId = _ref.msgChainId,
        sessionToken = _ref.sessionToken;

    _classCallCheck(this, ResendRangeRequest);

    _this = _super.call(this, version, ControlMessage_1.default.TYPES.ResendRangeRequest, requestId);
    validations_1.validateIsNotEmptyString('streamId', streamId);
    validations_1.validateIsNotNegativeInteger('streamPartition', streamPartition);
    validations_1.validateIsType('fromMsgRef', fromMsgRef, 'MessageRef', MessageRef_1.default);
    validations_1.validateIsType('toMsgRef', toMsgRef, 'MessageRef', MessageRef_1.default);
    validations_1.validateIsString('publisherId', publisherId, true);
    validations_1.validateIsString('msgChainId', msgChainId, true);
    validations_1.validateIsString('sessionToken', sessionToken, true);
    _this.streamId = streamId;
    _this.streamPartition = streamPartition;
    _this.fromMsgRef = fromMsgRef;
    _this.toMsgRef = toMsgRef;

    if (_this.fromMsgRef.timestamp > _this.toMsgRef.timestamp) {
      throw new ValidationError_1.default("fromMsgRef.timestamp (".concat(_this.fromMsgRef.timestamp, ")") + "must be less than or equal to toMsgRef.timestamp (".concat(_this.toMsgRef.timestamp, ")"));
    }

    _this.publisherId = publisherId;
    _this.msgChainId = msgChainId;
    _this.sessionToken = sessionToken;
    return _this;
  }

  return ResendRangeRequest;
}(ControlMessage_1.default);

exports.default = ResendRangeRequest;